/**
 * ResiBot / widget tenant id for ResiWeb embeds.
 *
 * ARCHITECTURE_PLAN.md: `data-tenant-id` must be the accommodation key in ResiBot MySQL
 * (e.g. studio_gocki), not a display name or raw email.
 *
 * Priority:
 * 1. REACT_APP_RESIBOT_TENANT_ID — per-deploy override (single-property build)
 * 2. REACT_APP_RESIBOT_DEFAULT_TENANT or "studio_gocki"
 *
 * We do not pass `username` verbatim as tenant (often an email); that breaks
 * GET /api/widget/config/{tenantId} when the DB row is keyed by property slug.
 */

const TENANT_ID_BY_DOMAIN = {
  "studiogocki.com": "studio_gocki",
  "hausclarysse.com": "haus_clarysse",
  "activemontgoflat.com": "active_montgo_flat",
  "thecityghent.com": "the_city_ghent",
};

export function isResibotEnabledDomain(username) {
  const domain = (username || "").trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(TENANT_ID_BY_DOMAIN, domain);
}

export function getWidgetTenantId(username) {
  const domain = (username || "").trim().toLowerCase();
  if (TENANT_ID_BY_DOMAIN[domain]) return TENANT_ID_BY_DOMAIN[domain];

  const explicit = process.env.REACT_APP_RESIBOT_TENANT_ID?.trim();
  if (explicit) return explicit.toLowerCase();

  const fallback =
    process.env.REACT_APP_RESIBOT_DEFAULT_TENANT?.trim().toLowerCase() ||
    "studio_gocki";

  if (!domain || domain === "default" || domain === "localhost") {
    return fallback;
  }

  const legacy =
    String(process.env.REACT_APP_RESIBOT_USE_USERNAME_AS_TENANT || "")
      .trim()
      .toLowerCase() === "true";
  if (legacy) {
    return (
      domain.replace(/[^a-z0-9_-]/g, "_").replace(/_+/g, "_").replace(/^_|_$/g, "") ||
      fallback
    );
  }

  return fallback;
}
